export default "__VITE_ASSET__DRtFZaH8__";